import { format, parseISO } from "date-fns";

export const PROJECT_STATUSES = ["Planning", "In Progress", "Review", "Completed", "On Hold"];

const STATUS_CLS = {
  Planning: "text-slate-300 border-slate-400/30 bg-slate-400/10",
  "In Progress": "text-cyan-300 border-cyan-400/40 bg-cyan-400/10",
  Review: "text-amber-300 border-amber-400/40 bg-amber-400/10",
  Completed: "text-emerald-300 border-emerald-400/40 bg-emerald-400/10",
  "On Hold": "text-red-300 border-red-400/40 bg-red-400/10",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex w-fit whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${STATUS_CLS[status]}`}>{status}</span>
);

export const ProgressBar = ({ value, testId }) => (
  <div className="flex items-center gap-3">
    <div className="h-2 flex-1 overflow-hidden rounded-full bg-white/5">
      <div className="h-full rounded-full bg-gradient-to-r from-cyan-400 to-blue-500 shadow-[0_0_12px_rgba(0,240,255,0.5)] transition-[width] duration-700" style={{ width: `${value}%` }} />
    </div>
    <span data-testid={testId} className="w-10 text-right font-mono-tech text-xs text-slate-300">{value}%</span>
  </div>
);

export const UnreadBadge = ({ count, testId }) =>
  count > 0 ? (
    <span data-testid={testId} className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-cyan-400 px-1.5 text-[11px] font-bold text-[#07090E]">{count}</span>
  ) : null;

export const fmtDue = (d) => (d ? format(parseISO(d), "MMM d, yyyy") : "No due date");

export const fmtSize = (b) => (b < 1024 ? `${b} B` : b < 1048576 ? `${(b / 1024).toFixed(1)} KB` : `${(b / 1048576).toFixed(1)} MB`);
